import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  fares: [],
  isLoading: false,
  hasData: false,
  error: ""
};
const OrderRetrieveSlice = createSlice({
  name: "orderRetrieve",
  initialState,
  reducers: {
    orderRetrieveDataRequest: (state, action) => {
      state.isLoading = true;
    },
    getorderRetrieveDataSuccess: (state, action) => {
      console.log(action.payload);
      state.isLoading = false;
      state.error = "";
      state.fares = action.payload;
      state.hasData = true;
    },
    getorderRetrieveDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = false;
    }
  }
});
export const {
  orderRetrieveDataRequest,
  getorderRetrieveDataSuccess,
  getorderRetrieveDataFailure
} = OrderRetrieveSlice.actions;
export default OrderRetrieveSlice.reducer;